/** @format */
/** @format */

import React, { FC, useEffect, useState } from 'react'
import {
  Button,
  Dialog,
  Icon,
  Message,
  Switch,
  Pagination,
  Table,
  TableColumn
} from '@king-design/react'
import styled from 'styled-components'
import { PageProps, initPage } from 'src/utils/interface'
import { MonitorSearch } from 'src/components'
import { useAsyncFn } from 'react-use'
import {
  getPrometheusRecordList,
  updatePrometheusRecordState,
  deletePrometheusRecord
} from 'src/api/ApiPromethuesInstance'
import RecordEditDrawer from './EditDrawer'

interface SearchProps extends PageProps {
  Name: string
}

const initSearch: SearchProps = {
  Name: '',
  ...initPage
}
interface PrometheusInstanceRecordProps {
  className?: string
  tab: string
  instanceID: string
}
const InstanceRecord: FC<PrometheusInstanceRecordProps> = ({ className, tab, instanceID }) => {
  const [search, setSearch] = useState<SearchProps>(initSearch)
  const [editVisible, setEditVisible] = useState<boolean>(false)
  const [editId, setEditId] = useState<number>()

  useEffect(() => {
    if (tab === 'record') {
      ruleFetch()
    }
  }, [tab, search])

  const [{ value: rules }, ruleFetch] = useAsyncFn(
    async (values?) => {
      const params = {
        ...search,
        ...values
      }
      const result = await getPrometheusRecordList(params)
      return {
        data: result?.Groups || [],
        total: result?.Count || 0
      }
    },
    [search]
  )

  // 更新规则状态
  const [, updateStateFetch] = useAsyncFn(async params => {
    const result = await updatePrometheusRecordState(params)
    if (result?.code === 'Success') {
      Message.success('更新成功')
      ruleFetch()
    }
  }, [])

  // 删除规则
  const [, deleteFetch] = useAsyncFn(async ID => {
    const result = await deletePrometheusRecord(ID)
    if (result?.code === 'Success') {
      Message.success('删除成功')
      ruleFetch()
    }
  }, [])

  return (
    <div className={className}>
      <div className="header">
        <Button
          type="primary"
          onClick={() => {
            setEditId(undefined)
            setEditVisible(true)
          }}
        >
          <Icon className="ion-plus-round" />
          新建预聚合
        </Button>
      </div>
      <div className="search_row">
        <div className="search_item">
          <p className="search_item_label">预聚合规则名称</p>
          <MonitorSearch
            placeholder="请输入预聚合规则名称，支持模糊搜索"
            onChange={value => {
              setSearch({
                ...search,
                Page: 1,
                Name: value
              })
            }}
          />
        </div>
      </div>
      <Table data={rules?.data || []} rowKey={data => data.ID} checkType="none" animation={false}>
        <TableColumn key="Name" title="预聚合规则名称" />
        <TableColumn key="RecordCount" title="规则组个数" />
        <TableColumn
          key="Status"
          title="规则状态"
          slotTemplate={([{ ID, Status, Name }]) => {
            return (
              <Switch
                on="开"
                off="关"
                value={Status === 1 ? true : false}
                beforeChange={async from => {
                  if (from) {
                    const result = await Dialog.confirm({
                      content: `是否确认停用【${Name}】的预聚合规则？`,
                      okText: '确认停用'
                    }).then(
                      res => {
                        return true
                      },
                      err => {
                        return false
                      }
                    )
                    return result
                  } else {
                    return true
                  }
                }}
                onChangeValue={value => {
                  updateStateFetch({ ID, Status: value ? 1 : 0 })
                }}
              />
            )
          }}
        />
        <TableColumn
          key="operate"
          title="操作"
          width="150"
          slotTemplate={([record]) => {
            return (
              <div className="ksc-space">
                <a
                  onClick={() => {
                    setEditId(record.ID)
                    setEditVisible(true)
                  }}
                >
                  编辑
                </a>
                <a
                  onClick={() => {
                    let dialog: Dialog
                    Dialog.confirm({
                      content: `是否确认删除【${record?.Name}】的预聚合规则？`,
                      ref: _dialog => (dialog = _dialog),
                      okText: '确认删除',
                      ok: async () => {
                        dialog.showLoading()
                        await deleteFetch(record?.ID)
                        dialog.close()
                      }
                    })
                  }}
                >
                  删除
                </a>
              </div>
            )
          }}
        ></TableColumn>
      </Table>
      <Pagination
        value={search.Page}
        limit={search.PageSize}
        total={rules?.total || 0}
        size="small"
        onChangeValue={value => {
          setSearch(state => {
            return {
              ...state,
              Page: value
            }
          })
        }}
        onChangeLimit={limit => {
          setSearch({
            ...search,
            PageSize: limit
          })
        }}
      />
      <RecordEditDrawer
        visible={editVisible}
        onClose={update => {
          setEditVisible(false)
          if (update) {
            ruleFetch()
          }
        }}
        instanceID={instanceID}
        ID={editId}
      />
    </div>
  )
}

export default styled(InstanceRecord)`
  margin-top: 16px;
  .search_row {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin-top: 16px;
    .search_item {
      display: flex;
      align-items: center;
      margin: 0 16px 16px 0;
      .search_item_label {
        margin: 0px 8px 0 0;
      }
    }
  }
  .k-pagination {
    margin-top: 16px;
    text-align: center;
  }
`
